import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.css']
})
export class ErrorDialogComponent {

  @Input() header = 'Confirmation';
  @Input() body = 'Are you sure you want to perform this action?';
  @Input() buttonText = 'Try Again';
  @Input() buttonClass = 'btn-danger';
  @Input() dismissOnConfirm = true;
  @Input() showCancel = true;
  @Input() showLoadingOnConfirmClick = true;
  @Output()
  onConfirmClicked = new EventEmitter();
  @Input() loading = false;

  constructor(
      public modalRef: BsModalRef,
  ) {
  }



  ngOnInit(): void {
  }

  onConfirm: any = () => {
  };

  close() {
    this.modalRef.hide();
  }

  confirm() {
    if (this.showLoadingOnConfirmClick) {
      this.loading = true;
    }
    this.onConfirm();
    this.onConfirmClicked.emit();
    if (this.dismissOnConfirm) {
      this.modalRef.hide();
    }
  }
}
